// import React, {useState, useContext, Fragment} from 'react';
import React, {useState, useEffect, useContext} from "react";
import  {UserContext} from "../../providers/UserProvider";

import {Button, FloatingLabel, Form} from 'react-bootstrap';
// import {Line} from "./helpers/blocks";

import BigText from './helpers/BigText';
import { keyListener, ShowTree } from "./helpers/blocks";
import LoadingPage from "./helpers/LoadingPage";

import './helpers/blocks.css';
import '../css/Components.css';

const LQV_Translation =({curQ, curQ2, curPi, setCurQComplete, type, setPartInst, setAnsSaved, btnClicked, allVerseQuestions}) =>{
	
	console.log("## Translation ##", curQ, curQ2);

	// To autosave when next or previous buttons are clicked
	useEffect(()=>{
		if (btnClicked===true){
			check();
			setAnsSaved(true);
		};
	}, [btnClicked]);

	// curQ.text.q is a list. 0th element is the qDeva and the rest of them are boxes	
	const [loading, setLoading] = useState(false);
	const {currentUser} =useContext(UserContext);

	// Use allVerseQuestions if provided, otherwise fallback to curQ/curQ2
	const [questions, setQuestions] = useState([]);
	const [qTexts, setQTexts] = useState([]);
	const [showText, setShowText] = useState('loading...');
	// Single verse-level answer state (one translation + optional comment for the whole verse)
	const [ansState, setAnsState] = useState({});
	const [completed, setCompleted] = useState("");

	useEffect(() => {
		// Use allVerseQuestions if provided, otherwise fallback to curQ/curQ2
		const allQuestions = (allVerseQuestions && allVerseQuestions.length > 0) 
			? allVerseQuestions 
			: [curQ, curQ2].filter(q => q && Object.keys(q).length > 0);
		setQuestions(allQuestions);
		
		if (allQuestions.length > 0) {
			const firstQ = allQuestions[0];
			try {
				if (firstQ.text && firstQ.text.meta && firstQ.text.meta.allComplete)
					setCompleted('all');
				else if (firstQ.text && firstQ.text.meta && firstQ.text.meta.primaryComplete)
					setCompleted('primary');
				else
					setCompleted('');
			} catch (err) {
				setCompleted('');
				console.log('got err:', err.message);
			}
			
			if (allQuestions.every(q => q.takeInput)){
				// Initialize verse-level answer state from the first question's uans, if present
				setAnsState(firstQ.uans || {});
				setQTexts(allQuestions.map(q => q.text && q.text.q ? q.text.q[0] : ''));
			}
		}
	}, [curQ, curQ2, allVerseQuestions]);

	useEffect(()=>{
		setShowText(qTexts.join("<br>"));
	}, [qTexts]);
	useEffect(()=>{
		console.log('showText:', showText);
	}, [showText])
	// console.log('completed', completed);

	const  handleInputChange =(event, type) => {
		const newAns = {...ansState};
		switch(type) {
			case "translation":
				newAns.translation = event.target.value;
				break;
			case "comment":
				newAns.comment = event.target.value;
				break;
			default:
				break;
		};
		setAnsState(newAns);
	};

	const handleToggle = (checked) =>{
		const newAns = {...ansState};
		newAns.addComment = checked;
		if (!newAns.addComment)
			newAns.comment = "";
		
		setAnsState(newAns);
	};

	const check =() => {
		const postObj = {
			method: 'POST',
			cache: 'no-cache',
			headers: {'Content-Type': 'application/json'},
			// For verse-level translation we send a single answer object (index 0)
			body: JSON.stringify({ uans: [ansState], curPart: 'translation',
											pi: curPi, email: currentUser.email,
											curQs: questions })
		}
		const getFeedback =async () => {
			setLoading(true);
			
			const response = await fetch(process.env.REACT_APP_FLASK_API+'check_lqv_uans', postObj);
			const data = await response.json();
			// console.log(data.analysis);
			// setCurQComplete(data.completed);
			setPartInst(data.instruction || data.analysis?.inst || '');
			setLoading(false);
		};
		getFeedback();
	};

	//Enter = Submit
	const [btn, setBtn]=useState(null);
	useEffect(() => {
		if (btn){
			// create an eventListener
			window.addEventListener('keydown', e=>keyListener(e, btn));
			// cleanup this component
			return () => {
				window.removeEventListener('keydown', e=>keyListener(e, btn));
			};
		}
	}, [btn]);
	
	if (questions.length > 0){
		const firstQ = questions[0];
		return (
			<div>
				<ShowTree xmlid={firstQ.vxmlid} completed={completed}/>
				
				{console.log("loading:", loading)}
				<LoadingPage loading={loading} />

				<div id='LQV_Translation'>
					{firstQ.takeInput &&
						<>
							<div className="d-flex align-items-center">
								<div className="d-flex-column">
									<span style={{fontFamily:'Shobhika'}}>
										<BigText sp="Q:" text={showText} colored={true}/> 
									</span>
									<div className="containerBox">
										{questions.map((q, questionIndex) => (
											q.text && q.text.q && q.text.q.slice(1).map((cur, index) => (
												<div className="detailsBox" key={`${questionIndex}-${index}`}>
													<div style={{fontFamily:'Shobhika', fontSize:'22pt'}}>
														{cur.title}
													</div>		
													<div className='line'/>
													
													{'inflection' in cur &&
														cur.inflection.length
														?<div>{cur.inflection}</div>
														: <br/>
													}
													{'pos' in cur &&
														cur.pos.length
														?<div>{cur.pos}</div>
														: <br/>
													}

													{'addRoot' in cur && cur.addRoot===true &&
														<div>{cur.root}, {cur.rootPos}</div>
													}
							
													<Form.Control style={{marginTop:'5px'}} className="text-center" type="text" value={cur.trans} readOnly />
							
													{'relation' in cur && 'parents' in cur &&
														cur.relation.length >0 &&
														<div style={{fontFamily:"Praja", fontSize:"20pt", textAlign:"center", marginTop:'10px'}}>
															<div style={{color:'#DAA520'}}>{cur.relation}</div>
															<div style={{marginTop:'-10px'}}>{cur.parents}</div>
														</div>
													}
													{'secondaryRelation' in cur && 'targets' in cur &&
														cur.secondaryRelation.length >0 &&
														<div style={{fontFamily:"Praja", fontSize:"20pt", textAlign:"center", marginTop:'10px'}}>
															<div style={{color:'#ACAC9A'}}>{cur.secondaryRelation}</div>
															<div style={{marginTop:'-10px'}}>{cur.targets}</div>
														</div>
													}
												</div>
											))
										))}
									</div>
								</div>
							</div>
				
							<div className="FlexBox">
								<BigText sp="A:" />
								
								<div className="ansContainer">
									{firstQ.takeInput &&
										<div style={{marginTop: '0px'}}>
											<div className="form-group">
												<FloatingLabel
														controlId="translation-verse"
														label="Translation"
												>
													<textarea
														autoFocus
														autoComplete="off"
														className="form-control"

														name="translation"
														id="translation-verse"
														aria-describedby="translationError-verse"
														
														placeholder="Type your translation"
														value={ansState.translation || ''}
														onChange={(e) => handleInputChange(e, "translation")}
														onFocus={e => {
															var val = e.target.value;
															e.target.value = '';
															e.target.value = val;
														}}
													/>
												</FloatingLabel>
											</div>

											<div className ="KeepRight">
												<label htmlFor ="commentBtn-verse" 
													className ="form-check-label"
													style ={{marginRight:'5px'}}
												>
													Add comment
												</label>
												<input
													type ="checkbox"
													id ="commentBtn-verse"
													name ="commentBtn-verse"
													className ="form-check-input"
													checked ={ansState.addComment || false}
													onChange ={e=>handleToggle(e.target.checked)}
												/>
											</div>

											{ansState.addComment===true &&
												<Form>
													<FloatingLabel
														controlId="comment-verse"
														label="Comment/Query"
													>
														<textarea
															autoComplete="off"
															className="form-control"

															name="comment"
															id="comment-verse"
															aria-describedby="commentError-verse"
															
															placeholder="Type your comment"
															value={ansState.comment || ''}
															onChange={(e) => handleInputChange(e, "comment")}
															onFocus={e => {
																var val = e.target.value;
																e.target.value = '';
																e.target.value = val;
															}}
														/>
													</FloatingLabel>
												</Form>
											}
										</div>
									}
									<div className="KeepRight" >
										<Button onClick={()=>check()}
											ref={node=>setBtn(node)}
										>
											Check All
										</Button>
									</div>		
								</div>
							</div>

						</>
					}
				</div>
			</div>
		);
	} else {
		return (<div><LoadingPage loading={true} /></div>)
	}
};

export default LQV_Translation;